import { SVG, SVGProps } from './svg'

export function IconDrawingSettingAutosaveOff(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 32 32">
      <path
        fillRule="evenodd"
        d="M13.146 15.146a.5.5 0 0 1 .708 0L16 17.293l2.146-2.147a.5.5 0 0 1 .708.708L16.707 18l2.147 2.146a.5.5 0 0 1-.708.708L16 18.707l-2.146 2.147a.5.5 0 0 1-.708-.708L15.293 18l-2.147-2.146a.5.5 0 0 1 0-.708z M9.046 14.194a7.001 7.001 0 0 1 13.415-1.893A6.502 6.502 0 0 1 20.5 25h-10a5.5 5.5 0 0 1-1.454-10.806zM10 15a6 6 0 0 1 11.703-1.868A5.5 5.5 0 0 1 20.5 24h-10a4.5 4.5 0 0 1-.5-8.973V15z"
      />
    </SVG>
  )
}
